import $ from "jquery";
import Timer from "@bd-utils/timer";
import Budget from "@bd-utils/budget";
import BackgroundAudio from "@bd-utils/background-audio";
import Tutorial from "@bd-utils/tutorial";
import CompletionPopup from "@bd-utils/completion-popup";
import ReportingPopup from "@bd-utils/reporting-popup";
import LocationInfo from "@bd-utils/location-info";
import OutroVideo from "@bd-utils/outro-video";
import ChallengeAudio from "@bd-utils/challenge-audio";
import CONFIG from "@bd-core/config";
import fb from "@bd-core/firebase";
import bdjs from "@bd-core/bdjs";
import { getState, store } from "@bd-stores/store";
import bdapi from "@bd-core/bd-api";
import Storage from "@bd-utils/storage";
import {
    setAllRoomIsCompleted,
    updatePlayerPageId,
    updateAttributes,
    removeRoomAnswers,
    updateisUsingTobyHint,
} from "@bd-core/firebase-actions";
import {
    setFinished,
    setRoomStatus,
    setTeamAnswers,
    setFinalTeamAnswers,
    getRoomStatus,
    setAllRoomCompleted,
    setIsMiddleState,
    setIsUsingTobyHint,
    getIsUsingTobyHint,
    setStartedAt,
    setShouldFinishAt,
    setFinishedAt,
    setSpendingBudget,
    setSpending,
    setIsOverBudget,
    setHintIsOpened,
} from "@bd-stores/game-progress";
import {
    setCurrentPageId,
    setCurrentPageType,
    getCurrentPageId,
    getCurrentPageType,
    currentPageIsMainRoom,
} from "@bd-stores/user-progress";

const GameLogic = {
    initialized: false,
    currentPageType: false,
    currentPageID: false,
    transisitonDuration: 275,

    async init() {
        if ($(".app").length < 1) return false;

        this.outroVideo = new OutroVideo();
        this.completionPopup = new CompletionPopup();
        this.timer = new Timer(this.onTimeOut.bind(this)); // Use ExtendedTimer here
        this.budget = new Budget();
        this.tutorial = new Tutorial();
        this.backgroundAudio = new BackgroundAudio();
        this.locationInfo = new LocationInfo();
        this.reportingPopup = new ReportingPopup();

        this.outroVideo.init();
        this.completionPopup.init();
        this.budget.init();
        this.backgroundAudio.init();
        this.locationInfo.init();
        this.reportingPopup.init();

        this.registerGlobalEvents();
        this.registerGlobalListener();

        // Initialize Firebase
        //-----------------------------------------------------------------------
        try {
            await fb.initializeGame();
        } catch (e) {
            console.error(e);
        }
        //-----------------------------------------------------------------------
    },

    pauseTimer() {
        this.timer.pauseTimer();
    },

    continueTimer() {
        this.timer.continueTimer();
    },

    setBudget(amount) {
        this.budget.setBudget(amount);
    },

    addToBudget(amount) {
        this.budget.addToBudget(amount);
    },

    subtractFromBudget(amount) {
        this.budget.subtractFromBudget(amount);
    },

    getBudget() {
        return this.budget.getBudget();
    },

    resetBudget() {
        this.budget.resetBudget();
    },

    pauseBudget() {
        this.budget.pause();
    },

    resumeBudget() {
        this.budget.resume();
    },

    registerGlobalListener() {
        const onRoomStatusChanged = (roomID, roomStatus) => {
            if (!roomStatus) return;
            const currentPageId = getCurrentPageId();
            const isCurrentPageMainroom = currentPageIsMainRoom();

            const possibleStatuses = [
                "is-status-open",
                "is-status-started",
                "is-status-completed",
            ];

            if (currentPageId == roomID) {
                const $status = $(".js-room-status");
                // prettier-ignore
                $status.removeClass(possibleStatuses);
                $status.addClass(roomStatus);
            }

            if (isCurrentPageMainroom) {
                const $roomItem = $(`.js-mainroom-item[data-page="${roomID}"]`);

                roomStatus === "is-status-completed"
                    ? $roomItem.addClass("is-completed")
                    : $roomItem.removeClass("is-completed");
            }

            if (roomStatus == "is-status-completed") {
                this.handleAfterRoomCompleted(roomID);

                /* Show completion popup */
                // const isRoomMiddleState = roomData?.isMiddleState || false;
                // const roomAnswers = roomData?.finalAnswers || {};
            } else {
                /*
                 * On status open & started it will check the state of completion popup
                 * status might changed since you can edit them via backend
                 * and when the room is set from finish to open or started, we need to reset the state of completion popup(to unseen)
                 */
                this.completionPopup.maybeResetState(roomID);
            }
        };

        const onRoomDataChanged = (e, eventData) => {
            const currentPageId = getCurrentPageId();
            const isCurrentPageMainroom = currentPageIsMainRoom();
            const roomsData = eventData?.data || false;
            let currentRoomIsFinish = false;
            let currentRoomHasAnswer = false;

            /**
             * @type {BD_StoreGameProgress['teamAnswers']}
             */
            let tmpTeamAnswers = {};

            /**
             * @type {BD_StoreGameProgress['finalTeamAnswers']}
             */
            let tmpFinalTeamAnswers = {};

            /**
             * @type {BD_StoreGameProgress['roomStatus']}
             */
            let tmpRoomStatus = {};

            /**
             * @type {BD_StoreGameProgress['isUsingTobyHint']}
             */
            let tmpUsingTobyHint = {};

            /**
             * @type {BD_StoreGameProgress['hints']}
             */
            let tmpHints = {};

            if (roomsData) {
                $.each(roomsData, (roomID, room) => {
                    // @ts-ignore
                    roomID = isNaN(roomID) ? roomID : parseInt(roomID);

                    //Handle room status changed
                    const roomStatus = room?.status;

                    if (roomStatus) {
                        onRoomStatusChanged(roomID, roomStatus);
                        tmpRoomStatus[roomID] = roomStatus;
                    }

                    //handle room answers changed
                    const teamAnswers = room?.answers || {};
                    const finalTeamAnswers = room?.finalAnswers || {};
                    const isUsingTobyHint = room?.isUsingTobyHint || false;
                    const hintIsOpened = room?.hints || {};

                    tmpTeamAnswers[roomID] = teamAnswers;
                    tmpFinalTeamAnswers[roomID] = finalTeamAnswers;
                    tmpUsingTobyHint[roomID] = isUsingTobyHint;
                    tmpHints[roomID] = hintIsOpened;

                    const isCompleted = roomStatus == "is-status-completed";
                    const isCurrentPage = currentPageId == roomID;

                    if (isCurrentPage) {
                        if (isCompleted) currentRoomIsFinish = true;
                        if (finalTeamAnswers) currentRoomHasAnswer = true;
                    }
                });
            }

            store.dispatch(setTeamAnswers(tmpTeamAnswers));
            store.dispatch(setFinalTeamAnswers(tmpFinalTeamAnswers));
            store.dispatch(setRoomStatus(tmpRoomStatus));
            store.dispatch(setIsUsingTobyHint(tmpUsingTobyHint));
            store.dispatch(setHintIsOpened(tmpHints));

            this.maybeAllRoomCompleted();

            if (!this.initialized) {
                this.initializePage(currentPageId, true);
                this.initialized = true;
            }

            //Set DOM for correct answer
            else if (
                currentRoomIsFinish ||
                currentRoomHasAnswer ||
                isCurrentPageMainroom
            ) {
                const currentTypePage = getCurrentPageType();
                const currComponent = bdjs.getComponent(currentTypePage);
                if (currComponent?.setGameState) currComponent.setGameState();
            }
        };

        const onTeamAttributesChanged = (e, eventData) => {
            const startedAt = eventData?.data?.startedAt || null;
            if (startedAt) {
                store.dispatch(setStartedAt(startedAt));
            }

            const shouldFinishAt = eventData?.data?.shouldFinishAt || null;
            if (shouldFinishAt) {
                store.dispatch(setShouldFinishAt(shouldFinishAt));
                this.timer.start(); // Start the timer
            }

            const isMiddleState = eventData?.data?.isMiddleState || false;
            store.dispatch(setIsMiddleState(isMiddleState));

            const finishedAt = eventData?.data?.finishedAt || null;
            if (finishedAt) {
                store.dispatch(setFinishedAt(finishedAt));
            }

            const spendingBudget = eventData?.data?.spendingBudget || 0;
            if (spendingBudget) {
                store.dispatch(setSpendingBudget(spendingBudget));
                bdjs.trigger("bd__spendingBudgetChanged");
            }

            const spending = eventData?.data?.spending || {};
            store.dispatch(setSpending(spending));

            const allocatedBudget = eventData?.data?.allocatedBudget || 0;
            if (
                allocatedBudget &&
                spendingBudget &&
                allocatedBudget < spendingBudget
            ) {
                store.dispatch(setIsOverBudget(true));
            }

            const isFinished = eventData?.data?.isFinished || false;
            if (!isFinished) return;

            store.dispatch(setFinished(true));
            this.timer.stopTimer();

            bdjs.showLoading();

            setTimeout(() => {
                $(".app").html("");

                setTimeout(() => this.onFinish(), this.transisitonDuration);
            }, this.transisitonDuration);
        };

        const onPlayersDataChanged = () => {
            this.locationInfo.render();
        };

        bdjs.listen("bd__playersStateChanged", onPlayersDataChanged);

        // This two listener is essentially the same, because
        // bd__roomDataChanged be triggered even if there's no data inside it,
        // but in case that logic changed, we still be able to init the current
        // page explicitly.with the subscribe function, so it is important to
        // keep it there
        // subscribe(onRoomDataChanged, "isFirebaseInitialized");
        bdjs.listen("bd__roomDataChanged", onRoomDataChanged);
        bdjs.listen("bd__teamAttributeChanged", onTeamAttributesChanged);

        this.listenGameProgressChanged();
    },

    registerGlobalEvents() {
        const $app = $(".app");

        $app.on("click", "[data-change-page]", this.changePage.bind(this));

        /* Open room briefing popup */
        $app.on("click", ".js-open-briefing", this.toggleBriefing);

        /* Close room briefing popup */
        $app.on("click", ".js-briefing-close", this.toggleBriefing);

        $app.on("click", ".js-seemore", this.handleMoreHint);

        $app.on("click", ".js-close-advice", this.handleMoreHint);

        $app.on("click", ".js-toby-hint", this.toggleHintPopup);

        $app.on("click", ".js-using-hint", this.onClickHint);

        $app.on("click", ".js-close-hint", this.toggleHintPopup);

        $app.on("click", ".js-go-to-completion", this.handleReflectionPopup);

        $(document).on("click", function (e) {
            const $elRoomBrief = $(".roomBrief");

            if ($elRoomBrief.length) {
                /**
                 * Check is element related to current event
                 * @param {HTMLElement} el
                 * @param {typeof e} e
                 * @returns {Boolean}
                 */
                const checkRelatedTarget = (el, e) => el.contains(e.target);

                const shouldClose = !checkRelatedTarget($elRoomBrief[0], e);
                if (shouldClose) $elRoomBrief.removeClass("is-open");
            }
        });

        $(window).on("resize", () => {
            const isFunction =
                typeof window.screenCalculationFunc === "function";
            if (isFunction) window.screenCalculationFunc(); // eslint-disable-line no-undef
        });
    },

    /**
     * This function is to listen an event when game progress was edited from backend
     */
    listenGameProgressChanged() {
        const onGameProgressChanged = (e, eventData) => {
            const shouldClearData = eventData?.data?.clearData || false;
            const needReload = eventData?.data?.needReload || false;
            const removedPlayer = eventData?.data?.removedPlayer || false;
            const teamStatusChangedTo =
                eventData?.data?.teamStatusChangedTo || false;
            const teamCode = eventData?.data?.teamCode || false;

            if (teamStatusChangedTo || teamCode) {
                bdapi.post("game/change-status", {
                    status: teamStatusChangedTo,
                    code: teamCode,
                });
            }

            if (removedPlayer == CONFIG.user.id) {
                bdapi.post("member/kick-member", {
                    member_id: removedPlayer,
                    from_admin: true,
                });
                window.location.reload();
            }

            if (shouldClearData || needReload) {
                updateAttributes({
                    clearData: null,
                    needReload: null,
                }).then(async () => {
                    /**
                     * Clear all data from previous game. Answers, Popup State
                     */
                    if (shouldClearData) {
                        Storage.remove("states");
                        try {
                            await removeRoomAnswers();
                        } catch (err) {
                            console.error(err);
                        }
                        updatePlayerPageId(null);
                    }

                    if (needReload) window.location.reload();
                });
            }
        };

        bdjs.listen("bd__teamAttributeChanged", onGameProgressChanged);
    },

    onFinish(isTimeout = false) {
        const video = isTimeout
            ? this.outroVideo.videoTimeout
            : this.outroVideo.videoFinish;

        try {
            if (video) {
                bdjs.hideLoading();
                this.outroVideo.showVideo(isTimeout);

                setTimeout(() => {
                    video.play().catch((error) => {
                        // Autoplay was blocked. Do something
                        console.error("Unable to start auto play", error);
                    });
                }, this.transisitonDuration);
            } else {
                this.outroVideo.afterPlay();
            }
        } catch (error) {
            console.error(error);
        }
    },

    handleAfterRoomCompleted(roomId) {
        const rooms = CONFIG?.game?.rooms || false;
        if (!Array.isArray(rooms) || !rooms.length) return;

        const room = rooms.find((r) => r?.id == roomId);

        // @ts-ignore
        let hintRisk = room?.room?.hints?.hint_risk || false;
        const isUsingTobyHint = getIsUsingTobyHint(roomId);

        const room_type = room?.room?.room_type;

        if (room_type === "match_card" && hintRisk !== "high") {
            // @ts-ignore
            const hints_puzzle_part_2 = room?.room?.puzzle_part_2?.toby_hint;
            hintRisk = hints_puzzle_part_2?.hint_risk_level;
        }

        setTimeout(() => {
            if (hintRisk === "high" && isUsingTobyHint) {
                this.reportingPopup.show(roomId);
            } else {
                this.completionPopup.show(roomId);
            }
        }, this.transisitonDuration);
    },

    openCompletionPopup() {
        const roomId = getCurrentPageId();
        this.completionPopup.show(roomId);
    },

    toggleHintPopup() {
        const $hintPopup = $(".js-hints-popup");
        const hasOpened = $hintPopup.hasClass("is-open");
        const isOpen = !hasOpened;

        $hintPopup.removeClass("is-feedback is-for-part-2");
        $hintPopup.toggleClass("is-open", isOpen);
    },

    onClickHint() {
        const roomId = getCurrentPageId();

        updateisUsingTobyHint(roomId).then(() => {
            $(".js-hints-popup").addClass("is-open is-feedback");
        });
    },

    checkCharacterAisoTxt() {
        const content = $(".js-briefing-aiso").text().length;

        if (content > 138) {
            $(".js-seemore").css("display", "block");
        } else {
            $(".js-seemore").css("display", "none");
        }
    },

    toggleBriefing() {
        const $tutorial = new Tutorial();
        const $briefingPopup = $(".js-briefing.popup");
        const currentPageId = getCurrentPageId();
        const isMainRoom = currentPageIsMainRoom();

        const rooms = CONFIG.game.rooms;

        // @ts-ignore
        const lastChallenge = rooms.findLast(
            // @ts-ignore
            (item) => item.hotspot_type === "challenge",
        );

        const lastChallengeId = lastChallenge.id;

        const hasOpen = $briefingPopup.hasClass("is-open");
        const isOpen = !hasOpen;

        if (lastChallengeId === currentPageId) {
            $briefingPopup.addClass("is-last-challenge");
        }

        if (isMainRoom) {
            $briefingPopup.addClass("is-mainroom");
        }

        if (isOpen) this.checkCharacterAisoTxt;

        $briefingPopup.toggleClass("is-open", isOpen);
        $(".app-blur").removeClass("is-blurred");

        if (!isOpen) {
            $tutorial.init(currentPageId);
        }
    },

    handleMoreHint(e, el) {
        const $briefingPopup = $(".js-briefing");
        const isOpened = $briefingPopup.hasClass("is-show-advice");
        const btnDisplay = isOpened ? "block" : "none";

        $briefingPopup.toggleClass("is-show-advice", !isOpened);
        $(el).css("display", btnDisplay);
    },

    handleReflectionPopup() {
        $(".js-room-reflection").removeClass("is-open");
        $(".js-room-completion").addClass("is-open");
    },

    playAudioChallenge() {
        const $audioChallenge = new ChallengeAudio();
        const currentPageId = getCurrentPageId();
        const $audio = $(".js-audio-challenge");

        const hasPlayed = $audio.hasClass("is-played");

        if (!hasPlayed) {
            $audioChallenge.init(currentPageId);
        }
    },

    changePage(e) {
        const $el = $(e.currentTarget);
        const pageId = $el.attr("data-change-page");

        if ($el.hasClass("is-locked") || $el.parent().hasClass("is-notready")) {
            return;
        }

        this.goToPage(pageId);
    },

    handleTransitionPage(roomId) {
        const rooms = CONFIG.game.rooms;
        // @ts-ignore
        const lastChallenge = rooms.findLast(
            // @ts-ignore
            (item) => item.hotspot_type === "challenge",
        );
        const lastChallengeId = lastChallenge.id;

        if (roomId === lastChallengeId) {
            $(".js-screen-alert").addClass("is-alert");
        }
    },

    goToPage(pageId) {
        const currentPageId = getCurrentPageId();
        if (currentPageId == pageId) return;
        bdjs.showLoading();
        $(".site").removeClass("overlay-opened");

        setTimeout(() => {
            this.initializePage(pageId);
        }, this.transisitonDuration);
    },

    async onTimeOut() {
        bdjs.showLoading();

        const shouldFinishAt = getState().gameProgress.shouldFinishAt;

        await bdjs.goAsync(
            bdapi.post("game/timeout", { should_finish_at: shouldFinishAt }),
        );

        setTimeout(() => {
            $(".app").html("");

            this.onFinish(true);
        }, this.transisitonDuration);
    },

    initializePage(pageId, dontUpdate) {
        pageId = isNaN(parseInt(pageId)) ? pageId : parseInt(pageId);
        updatePlayerPageId(pageId);

        const pageData = this.getPageData(pageId);
        const component = bdjs.getComponent(pageData.type);
        const currentPageType = getCurrentPageType();

        if (component) {
            // this.hideComponent();

            if (currentPageType) {
                const prevComponent = bdjs.getComponent(currentPageType);

                if (prevComponent) {
                    prevComponent.destroy();
                }
            }

            store.dispatch(setCurrentPageId(pageId));
            store.dispatch(setCurrentPageType(pageData.type));

            component._setData(pageData.data);
            component.init();

            this.initKeyboardScrolling();

            this.locationInfo.render();

            if (!dontUpdate) {
                updatePlayerPageId(pageId);
            }

            $(".app-blur").removeClass("is-blurred");
            this.handleTransitionPage(pageId);

            this.listenScreenLoading();
        } else {
            console.error("Component: Can't find component " + pageData.type);
        }
    },

    getPageData(pageId) {
        let _data = {};

        /**
         * @type {BD_RoomType | undefined}
         */
        let _type = undefined;

        $.each(CONFIG.game.rooms, (index, room) => {
            if (room.id == pageId) {
                _type = room.type;
                _data = room.room;
                return false;
            }
        });

        return {
            type: _type,
            data: _data,
        };
    },

    listenScreenLoading() {
        /**
         * @type {JQuery<HTMLImageElement>}
         */
        const $screenImg = $(".screen__img");

        const isScreenImgExist = $screenImg.length > 0;
        const currentPageId = getCurrentPageId();

        const onLoaded = () => {
            const isFunction =
                typeof window.screenCalculationFunc === "function";

            if (isScreenImgExist) {
                if (isFunction) window.screenCalculationFunc();
            }

            setTimeout(() => {
                const userProgress = getState().userProgress;
                const isInitialized = userProgress.isFirebaseInitialized;
                const isCurrentPageMainroom = currentPageIsMainRoom();
                if (isInitialized && !isCurrentPageMainroom) bdjs.hideLoading();

                //Setup Tutorial
                this.tutorial.init(currentPageId);
            }, this.transisitonDuration);
        };

        if (!isScreenImgExist) return onLoaded();
        if ($screenImg[0].complete) return onLoaded();
        $screenImg.on("load", onLoaded);
        $screenImg.on("error", onLoaded);
    },

    maybeAllRoomCompleted() {
        const rooms = CONFIG.game.rooms;
        let isAllRoomCompleted = true;

        $.each(rooms, (index, room) => {
            if (
                room.type === "main-room" ||
                room.type === "no_challenge" ||
                room.type === "hint" ||
                room.type === "audio"
            )
                return true;

            const roomStatus = getRoomStatus(room.id);

            if (roomStatus !== "is-status-completed") {
                isAllRoomCompleted = false;
                return false;
            }
        });

        if (isAllRoomCompleted) {
            setAllRoomIsCompleted(true);
            store.dispatch(setAllRoomCompleted(true));
        }
    },

    initKeyboardScrolling() {
        const scrollableBoxes = document.querySelectorAll(".scrollable-box");

        if (!scrollableBoxes.length) return;

        const scrollAmount = 40;

        const handleKeyboardScroll = (event) => {
            switch (event.key) {
                case "ArrowUp":
                    event.preventDefault();
                    scrollableBoxes.forEach((box) => {
                        box.scrollBy({
                            top: -scrollAmount,
                            behavior: "smooth",
                        });
                    });
                    break;

                case "ArrowDown":
                    event.preventDefault();
                    scrollableBoxes.forEach((box) => {
                        box.scrollBy({ top: scrollAmount, behavior: "smooth" });
                    });
                    break;

                case "ArrowLeft":
                    event.preventDefault();
                    scrollableBoxes.forEach((box) => {
                        box.scrollBy({
                            left: -scrollAmount,
                            behavior: "smooth",
                        });
                    });
                    break;

                case "ArrowRight":
                    event.preventDefault();
                    scrollableBoxes.forEach((box) => {
                        box.scrollBy({
                            left: scrollAmount,
                            behavior: "smooth",
                        });
                    });
                    break;

                default:
                    return;
            }
        };

        document.addEventListener("keydown", handleKeyboardScroll);

        this.keyboardScrollHandler = handleKeyboardScroll;
    },

    /**
     * Remove keyboard scrolling event listener
     */
    removeKeyboardScrolling() {
        if (this.keyboardScrollHandler) {
            document.removeEventListener("keydown", this.keyboardScrollHandler);
            this.keyboardScrollHandler = null;
        }
    },
};

export default GameLogic;
